<script>
export default {}
</script>

<template>
  <div class="subNav flex flexRow flexAlStretch flexJustEnd z-50">
    <slot />
  </div>
</template>

<style lang="scss">
@import '@design';

.subNav {
  z-index: 10;
}
</style>
